import { CatIconExternalLinkBox } from 'blocks-nextjs/blocks-react/components/Icons/ExternalLinkBox';
import styles from './FooterLegalLinks.module.scss';
import cx from 'classnames';

export interface LegalLink {
  name: string;
  url: string;
  display: boolean;
  target?: string;
  label: string;
  className?: string;
}

interface FooterLegalLinksProps {
  legalLinks: LegalLink[];
  isFooterDesignUpdate: boolean
}

export const FooterLegalLinks = ({ legalLinks , isFooterDesignUpdate }: FooterLegalLinksProps) => {
  const ShouldShowIcons = isFooterDesignUpdate;
   return (
    <div className={styles['footer__legal__links-box']}>
      {legalLinks
        ?.filter((legalLink) => legalLink.display)
        .map((legalLink) => (
          <a
            href={legalLink.url} 
            target={legalLink.target} 
            key={legalLink.name}
            className={cx(
              styles['footer__legal__links-link'],
              legalLink.className,
              'exclude-global',
              {
                [styles['with-icon']]: ShouldShowIcons,
              }
              
            )}
            aria-label={legalLink.label}
          >
            <div 
              className={cx(
              styles['footer__legal__links-link-container'],
              )}>
                {
                  ShouldShowIcons && (
                    <CatIconExternalLinkBox className={styles['footer__legal__links-icon']}/> 
                  )
                }
             {legalLink.label}
            </div>
          </a>
        ))}
    </div>
  );
};
